import { InMemoryCache } from '../../cache/InMemoryCache';
import identity from 'transmute/identity';
import { fetchLeadPipelineSettings } from './leadPipelineSettingsApi';
export const makeLeadPipelineSettingsCache = () => new InMemoryCache('LeadPipelineSettingsCache', fetchLeadPipelineSettings, identity);
export const cache = makeLeadPipelineSettingsCache();

// exported for unit test usage only
export const _resetCache = () => {
  cache.clear();
};